var render, staticRenderFns
import script from "./krThByGm.vue?vue&type=script&lang=js&"
export * from "./krThByGm.vue?vue&type=script&lang=js&"
import style0 from "./krThByGm.vue?vue&type=style&index=0&id=0f023d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f023d52",
  null
  
)

export default component.exports